import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'smh-dialog-foto-preview',
    templateUrl: './foto-preview.component.html',
    styleUrls: [],
    standalone: false
})
export class FotoPreviewComponent  {
  /**
   * constructor
   * @param data
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: {images: any, loading: boolean}) {}

  /**
   * de/activates the loading animation when in the overlay.
   * @param loading
   */
  setLoading(loading: boolean): void {
    this.data.loading = loading;
  }
}
